export const defaultData = {
  installerDetails: {
    companyName: '',
    mcsNumber: '',
    engineerName: '',
    engineerPhone: '',
    engineerEmail: ''
  },
  siteDetails: {
    clientName: '',
    installationAddress: '',
    postCode: '',
    contactPhone: '',
    commissioningDate: new Date().toISOString().split('T')[0]
  },
  equipmentSpecification: {
    hpManufacturer: '',
    hpModel: '',
    hpSerialNumber: '',
    systemType: 'Monobloc',
    refrigerantType: 'R32',
    refrigerantChargeKg: 1.8,
    gwp: 675,
    cylinderMakeModel: '',
    cylinderCapacityLtrs: 200,
    bufferVesselCapacityLtrs: 50
  },
  designParameters: {
    designHeatLossKw: 8.0,
    externalDesignTempC: -3.0,
    internalDesignTempC: 21.0,
    designFlowTempC: 45.0,
    designReturnTempC: 40.0,
    designDeltaTC: 5.0,
    designFlowRateLpm: 23.5,
    emitterType: 'Low Temp Radiators',
    weatherCompensationFitted: 'Yes',
    heatPumpEfficiencyScop: 3.8
  },
  waterQualityAndAntifreeze: {
    systemFlushedBS7593: 'Yes',
    magneticFilterInstalled: 'Yes',
    glycolBrand: 'Fernox HP-5c / Sentinel R100',
    glycolConcentrationPct: 25,
    freezeProtectionTempC: -11,
    refractometerReadingBrix: 14.0,
    primaryWaterPh: 8.2,
    inhibitorAdded: 'Yes'
  },
  commissioningMeasurements: {
    measuredFlowRateLpm: 23.0,
    measuredFlowTempC: 45.0,
    measuredReturnTempC: 40.2,
    measuredDeltaTC: 4.8,
    expansionVesselPreChargeBar: 1.5,
    systemColdPressureBar: 1.5,
    defrostCycleTested: 'Yes',
    dhwDisinfectionConfigured: 'Yes',
    immersionHeaterTested: 'Yes'
  },
  electricalAndControls: {
    dnoNotificationStatus: 'Connect & Notify (G98/G100)',
    dnoReferenceNumber: '',
    isolatorInstalledNearOutdoorUnit: 'Yes',
    rcdTypeFitted: 'Type A 30mA',
    controllerLocation: 'Hallway / Living Room'
  },
  handoverAndDeclarations: {
    userManualSupplied: 'Yes',
    controlsDemonstrated: 'Yes',
    mcsHandoverPackProvided: 'Yes',
    engineerComments: 'System commissioned fully in accordance with MCS MIS 3005 and manufacturer commissioning guidelines.',
    engineerSignature: '',
    customerSignature: ''
  }
};

export default defaultData;
